export default "__VITE_ASSET__BtzzO3mG__"